/** An asset's display name: year make model, else its plate, else "Asset". */
export type AssetNameParts = {
  year?: number | null;
  make?: string | null;
  model?: string | null;
  registration_plate?: string | null;
};

export function assetName(v: AssetNameParts): string {
  return [v.year, v.make, v.model].filter(Boolean).join(' ') || v.registration_plate || 'Asset';
}
